import { DayType, WeekDays } from '@griply/types';

import { getWeekDays } from '../get-week-days';

export const getMonthDayOrdinals = (weekStartsOn?: WeekDays) => [
  ...getWeekDays(weekStartsOn),
  ...Object.values(DayType),
];
